import { Theme } from "@emotion/react";

export type ColorProp = keyof Theme["colors"] | (string & {});

function isThemeColor(color: string, theme: Theme): color is keyof Theme["colors"] {
  return Object.keys(theme.colors).includes(color);
}

/**
 * Converts a color string into the corresponding color from the theme if it exists.
 *
 * If the color is not found in the theme, it returns the original color string.
 *
 * Undefined can only be returned if the input color can be undefined
 */
export function getColorFromTheme(color: ColorProp, theme: Theme): string;
export function getColorFromTheme(color: ColorProp | undefined, theme: Theme): string | undefined;
export function getColorFromTheme(color: ColorProp | undefined, theme: Theme): string | undefined {
  if (color === undefined) {
    return undefined;
  }

  if (isThemeColor(color, theme)) {
    return theme.colors[color];
  }

  return color;
}
